import { render } from "./DatabaseBackupView.vue?vue&type=template&id=29524bb7&scoped=true"
import script from "./DatabaseBackupView.vue?vue&type=script&lang=js"
export * from "./DatabaseBackupView.vue?vue&type=script&lang=js"

import "./DatabaseBackupView.vue?vue&type=style&index=0&id=29524bb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29524bb7"]])

export default __exports__